{
  "title": "Управление графиками",
  "actions": {
    "save": "Сохранить график",
    "update": "Обновить",
    "saveChanges": "Сохранить",
    "revert": "Отменить",
    "saveAsNew": "Сохранить как копию"
  },
  "tabs": {
    "label": "Графики",
    "draft": "Новый график",
    "saveAction": "Сохранить график",
    "newAction": "Новый график",
    "delete": "Удалить график «{{name}}»",
    "unsaved": "есть несохранённые изменения",
    "rename": "Переименовать",
    "share": "Поделиться с коллегами",
    "unshare": "Закрыть доступ",
    "remove": "Удалить",
    "shared": "Поделился(-ась) {{owner}}",
    "renameLabel": "Название графика"
  },
  "panel": {
    "title": "Выбор устройств",
    "from": "Дата начала",
    "to": "Дата окончания",
    "search": "Поиск устройства",
    "all": "Все",
    "selected": "Выбрано: {{count}}",
    "clear": "Очистить",
    "apply": "Применить",
    "noCategory": "Без категории",
    "notFound": "Ничего не найдено",
    "noIndicators": "У объекта пока нет показателей",
    "pickDate": "Выбрать дату",
    "dateInvalid": "Неверная дата — ДД.ММ.ГГГГ",
    "limit": "На одном графике не больше {{max}} показателей",
    "expand": "{{name}} — развернуть",
    "collapse": "{{name}} — свернуть"
  },
  "periods": {
    "label": "Период",
    "1d": "1 ДЕНЬ",
    "7d": "7 ДНЕЙ",
    "30d": "30 ДНЕЙ",
    "all": "Все",
    "custom": "Свой"
  },
  "summary": "{{from}} - {{to}}  -  измерений: {{count}}",
  "views": {
    "label": "Вид",
    "chart": "График",
    "table": "Таблица"
  },
  "legend": {
    "updated": "Последнее обновление: {{time}}",
    "toggle": "{{name}} — показать или скрыть",
    "missing": "Не найдено показателей: {{count}}"
  },
  "kpi": {
    "min": "Мин",
    "max": "Макс",
    "avg": "Сред"
  },
  "thresholds": {
    "warning": "Предупреждение",
    "danger": "Граница опасности"
  },
  "table": {
    "time": "Время",
    "status": "Состояние"
  },
  "status": {
    "normal": "В норме",
    "m1": "Предупреждение",
    "m2": "Опасно"
  },
  "empty": {
    "title": "Показатели не выбраны",
    "text": "Отметьте показатели в списке справа и нажмите «Применить».",
    "noData": "За выбранный период нет измерений",
    "noDataText": "Попробуйте выбрать другой период."
  },
  "save": {
    "title": "Сохранить график",
    "name": "Название графика",
    "nameHint": "Название показывается на вкладке вверху",
    "series": "Выбранные устройства ({{count}})",
    "seriesSearch": "Поиск среди выбранных",
    "seriesHint": "Прокрутите список или воспользуйтесь поиском. Цвета на графике могут повторяться",
    "remove": "Убрать «{{name}}»",
    "keepPeriod": "Сохранить и период",
    "allPeriod": "Весь период",
    "share": "Поделиться с коллегами",
    "shareHint": "График увидят и другие сотрудники объекта",
    "saved": "График сохранён",
    "savedText": "«{{name}}» добавлен на вкладки вверху",
    "updated": "Изменения сохранены",
    "nameTaken": "График с таким названием уже есть",
    "nameRequired": "Введите название графика",
    "noSeries": "Выберите хотя бы один показатель",
    "cancel": "Отмена",
    "submit": "Сохранить"
  },
  "delete": {
    "title": "Удалить график?",
    "text": "График «{{name}}» будет удалён.",
    "confirm": "Удалить",
    "done": "График удалён"
  },
  "rename": {
    "saved": "Переименовано"
  },
  "share": {
    "on": "Доступ открыт",
    "off": "Доступ закрыт"
  },
  "refreshed": "Данные обновлены",
  "error": {
    "load": "Не удалось загрузить данные",
    "retry": "Повторить",
    "generic": "Произошла ошибка"
  },
  "common": {
    "close": "Закрыть",
    "cancel": "Отмена"
  }
}
